import React, { useState, useEffect } from "react";
import { Navigation, Pagination, Autoplay, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./slider.css";
import { server } from "../../common";
import { toast } from "react-toastify";


const Slider = () => {
  const [data, setData] = useState([]);
console.log(data,"datadatadata")

    const getData = () => {
      server
        .get("/slider/getallslider")
        .then((response) => {
          if (response.status === 200) {
            setData(response.data);
          }
        })
        .catch((error) => {
          toast.error("Failed to load gallery");
        });
    };

      useEffect(() => {
        getData();
      }, []);

  return (
    <>
     



      <div className="align-self-center">
  <div className="swiper-container">
    <Swiper
      modules={[Navigation, Pagination, Autoplay, A11y]}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      autoplay={{
        delay: 2000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }}
      loop={true}
    >
      {data.map((item) => (
        <SwiperSlide key={item.id} className="flex justify-center items-center">
          {/* फक्त images render करायचेत */}
          {item.image_url.endsWith(".jpg") ||
          item.image_url.endsWith(".jpeg") ||
          item.image_url.endsWith(".png") ? (
            <img
              src={item.image_url}
              alt={item.title}
              className="swiper-slide-image"
              
            />
          ) : (
            <p className="text-center text-red-500">
              {item.title} (Not an image)
            </p>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</div>

    </>
  );
};

export default Slider;
// import React, { useState, useEffect } from "react";
// import { Navigation, Pagination, Autoplay, A11y } from "swiper";
// import { Swiper, SwiperSlide } from "swiper/react";
// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
// import "./slider.css";
// import { server } from "../../common";
// import { toast } from "react-toastify";


// const Slider = () => {
//   const [data, setData] = useState([]);
// console.log(data,"datadatadata")

//     const getData = () => {
//       server
//         .get("/slider/getallslider")
//         .then((response) => {
//           if (response.status === 200) {
//             setData(response.data);
//           }
//         })
//         .catch((error) => {
//           toast.error("Failed to load gallery");
//         });
//     };

//       useEffect(() => {
//         getData();
//       }, []);

//   return (
  
//     <div className="align-self-center">
//       <div className="swiper-container">
//         <Swiper
//           modules={[Navigation, Pagination, Autoplay, A11y]}
//           slidesPerView={1}
//           navigation
//           pagination={{ clickable: true }}
//           autoplay={{
//             delay: 2000,
//             pauseOnMouseEnter: true,
//             disableOnInteraction: false,
//           }}
//           loop={true}
//         >
//           {data.map((item) => (
//             <SwiperSlide key={item.id}>
//               {/* फक्त images render करायचेत */}
//               {item.image_url.endsWith(".jpg") ||
//               item.image_url.endsWith(".jpeg") ||
//               item.image_url.endsWith(".png") ? (
//                 <img
//                   src={item.image_url}
//                   alt={item.title}
//                   className="swiper-slide-image"
//                 />
//               ) : (
//                 <p className="text-center text-red-500">
//                   {item.title} (Not an image)
//                 </p>
//               )}
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </div>
//   );
// };
// export default Slider;
